export enum PostTargetTypes {
  AUTHOR = 'AUTHOR',
  ORGANIZATION = 'ORGANIZATION',
}
